<template>
  <dimmed>
    <content-box class="confirm-funnel-page--wrap" :width="'530px'">
      <p class="info-icon">
        <i :class="`icon ${iconClass}`"></i>
      </p>
      <p class="title" v-html="$t(`dialog.dashboard.${dialogType}.title`)"></p>
      <p class="desc" v-html="$t(`dialog.dashboard.${dialogType}.desc`, { pageName })"></p>
      <div class="table--wrap">
        <table>
          <thead>
            <tr>
              <th width="267" class="funnel-name">{{ $t('common.table.header.funnelName') }}</th>
              <th width="98" class="funnel-state">{{ $t('common.table.header.status') }}</th>
              <th width="105" class="funnel-date">{{ $t('common.table.header.createdAt') }}</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(item, index) in items" :key="index">
              <td class="funnel-name">
                <div class="ellipsis" style="width:267px;">
                  {{ item.name }}
                </div>
              </td>
              <td width="98" class="funnel-state" :class="item.state">
                {{ $t(`funnel.state.${item.state}`) }}
              </td>
              <td width="105" class="funnel-date">
                {{ item.regDate | dateFormatTimezone(userData.timezoneName) }}
              </td>
            </tr>
          </tbody>
        </table>
      </div>
      <p class="action">
        <ui-button class="btn-no"
          primary3
          @click="onCloseLayer(false)">{{ $t('common.cancel') }}</ui-button>
        <ui-button v-if="mode === 'stop'"
          primary2
          @click="onCloseLayer(true)">{{ $t('dialog.dashboard.stopFunnel.pause') }}</ui-button>
        <ui-button v-else
          primary2
          @click="onCloseLayer(true)">{{ $t('common.delete') }}</ui-button>
      </p>
    </content-box>
  </dimmed>
</template>

<script>
import ContentBox from '@/components/ui/ContentBox'
import UiButton from '@/components/ui/UiButton'
import Dimmed from '@/components/ui/Dimmed'
import { mapState } from 'vuex'

export default {
  components: {
    ContentBox,
    UiButton,
    Dimmed
  },
  props: [
    'checkData'
  ],
  data () {
    return {

    }
  },
  computed: {
    ...mapState([
      'userData'
    ]),
    mode () {
      return this.checkData.mode
    },
    pageName () {
      return this.checkData.pageName
    },
    items () {
      return this.checkData.items
    },
    iconClass () {
      return this.mode === 'stop' ? 'icon--pause' : 'icon--dialog-trash'
    },
    dialogType () {
      return this.mode === 'stop' ? 'stopFunnel' : 'deleteFunnel'
    }
  },
  methods: {
    onCloseLayer (value) {
      this.$close(value)
    }
  }
}
</script>

<style lang="scss" scoped="scoped">
.confirm-funnel-page--wrap {
  @include positionXYcenter;
  padding: 30px 30px 25px 30px;
  box-sizing: border-box;
  text-align: center;

  .info-icon {
    padding-top: 20px;
    margin-bottom: 15px;
  }

  .title {
    font-size: 20px;
    font-weight: bold;
    color: #444;
    margin-bottom: 12px;
  }
  .desc {
    font-size: 14px;
    line-height: 1.43;
    color: #2f2f2f;
  }

  .table--wrap {
    margin-top: 20px;
    position: relative;

    table {
      text-align: center;
      table-layout: fixed;
      border-collapse: collapse;

      thead {
        tr {
          display: block;
          background-color: #555;
          th {
            position: relative;
            height: 40px;
            box-sizing: border-box;
            color: #fff;
            line-height: 1.23;

            &:first-of-type:before,
            &:last-of-type:before {
              content: "";
              display: inline-block;
              width: 15px;
              height: 40px;
              position: absolute;
              top: 0;
              left: -5px;
              background-color: #555;
              border-radius: 5px;
            }

            &:last-of-type:before {
              left: auto;
              right: -5px;
            }

            &.funnel-name {
              padding-left: 10px;
              text-align: left;
            }
            &.funnel-state {
              text-align: left;
              padding-left: 38px;
            }
            &.funnel-date {
              padding-left: 22px;
              text-align: left;
            }
          }
        }
      }
    }

    tbody {
      display: block;
      width: 100%;
      height: 181px;
      overflow-y: scroll;
      tr {
        height: 60px;
        border-bottom: 1px solid #ebebeb;
      }

      td {
        &.funnel-name {
          font-size: 14px;
          font-weight: bold;
          color: #2f2f2f;
          text-align: left;
          padding-left: 10px;
          width: 267px;
          .ellipsis {
            width: 257px;
          }
        }
        &.funnel-state {
          font-size: 13px;
          font-weight: bold;

          &.start {
            color: $stateRunColor;
          }
          &.ing {
            color: $stateAnalyzingColor;
          }
          &.stop {
            color: $stateStopColor;
          }
          &.deleted {
            color: $errorColor;
          }
        }
        &.funnel-date {
          font-size: 13px;
          color: #666;
        }
      }
    }
  }

  .action {
    padding-top: 25px;
    .btn-no {
      margin-right: 5px;
    }
  }
}
</style>
